import { useQuery } from '@tanstack/react-query';

import type { Board } from '@tasks/contracts';

import { getBoard, type BoardParams } from '../../api/board';
import { queryKeys } from '../../api/queryKeys';
import { serializeParams } from '../../hooks/useUrlState';

export type BoardView = {
  readonly board: Board | null;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly error: unknown;
  refetch: () => void;
};

/** Доска — единственный источник данных; вид определяется URL-параметрами. */
export function useBoard(projectKey: string, params: BoardParams): BoardView {
  const serialized = serializeParams(params as Record<string, string | number | null | undefined>);
  const query = useQuery({
    queryKey: queryKeys.board.view(projectKey, serialized),
    queryFn: ({ signal }) => getBoard(projectKey, params, signal),
    enabled: projectKey.length > 0,
    staleTime: 10_000,
  });

  return {
    board: query.data ?? null,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: () => {
      void query.refetch();
    },
  };
}
